import React, { useEffect, useState } from "react";
import { Header } from "../../components/SpearParts/Layouts/Header";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import Axios from "../../axios/axios";
import { toTitleCase } from "../../components/utils/StringUtil";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

export default function PaymentOptions() {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch customer details including bank information
  useEffect(() => {
    const fetchCustomerDetails = async () => {
      try {
        // Get the customer ID from sessionStorage or localStorage (if it's available)
        const userInfoString = sessionStorage.getItem("userInfo");
        if (!userInfoString) {
          setError("No user info found.");
          setLoading(false);
          return;
        }

        const userInfo = JSON.parse(userInfoString);

        // Fetch customer data (assuming you have an API endpoint for this)
        const response = await Axios.get(
          `/customer/get/${userInfo.customerId}`
        );

        if (response.status === 200) {
          setCustomer(response.data);
        } else {
          setError("Failed to fetch customer data.");
        }
      } catch (err) {
        setError("Error fetching customer details");
      } finally {
        setLoading(false);
      }
    };

    fetchCustomerDetails();
  }, []);

  // If the data is still loading, show a loading message
  if (loading) return <div>Loading...</div>;

  // If there is an error, show an error message
  if (error) return <div>{error}</div>;
  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };

  return (
    <div style={sectionStyle}>
      {/* <Header /> */}
      {/* <div className="responsive-break"></div> */}
      <div className="Main-div">
        <TopNavBar />
        <div className="TopSearchBar">
          <TopSearchBar />
        </div>
        <section className="orders payment-opt  ">
          <div className="container">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb p-0">
                <li>
                  <a href="search-result.html" className="back">
                    <i className="fa fa-long-arrow-left" aria-hidden="true"></i>{" "}
                    &nbsp;&nbsp;
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/account">Account</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Payment options
                </li>
              </ol>
            </nav>

            <div className="row">
              <div className="col-lg-7">
                <h3 className="text-uppercase mb-lg-5">Payment options</h3>
              </div>
            </div>

            {/* Display Customer Bank Information */}
            {customer && (
              <div className="row">
                <div className="col-lg-6">
                  <div className="opt-div">
                    <img
                      src="/images/bank1.jpg"
                      alt="payment option"
                      height={200}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="row">
                    <div className="col-lg-4">
                      <p className="payment-title">Bank Name:</p>
                    </div>
                    <div className="col-lg-8">
                      <h6 className="payment-title">
                        {toTitleCase(customer.bankName)}
                      </h6>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <p className="payment-title">Bank Address:</p>
                    </div>
                    <div className="col-lg-8">
                      <h6 className="payment-title">
                        {toTitleCase(customer.bankAddress)}
                      </h6>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <p className="payment-title">Account No:</p>
                    </div>
                    <div className="col-lg-8">
                      <h6 className="payment-title">
                        {customer.accountNumber}
                      </h6>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <p className="payment-title">Currency:</p>
                    </div>
                    <div className="col-lg-8">
                      <h6 className="payment-title">{customer.currency}</h6>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <p className="payment-title">IBAN Number:</p>
                    </div>
                    <div className="col-lg-8">
                      <h6 className="payment-title">{customer.ibanNumber}</h6>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <p className="payment-title">SWIFT:</p>
                    </div>
                    <div className="col-lg-8">
                      <h6 className="payment-title">{customer.swift}</h6>
                    </div>
                    {/* <img src="/images/payment2.png" alt="payment option"/> */}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>

      {/* <Footer /> */}
    </div>
  );
}
